import React from "react";

/**
 * Brand motto in English Devanagari calligraphy (Samarkan).
 * Text only — matches the classic shirorekha Latin look.
 */
const BrandTagline = ({ className = "", light = false, withParens = false }) => {
  const text = withParens ? "(aarogyameva artha)" : "aarogyameva artha";
  return (
    <p
      className={`sv-brand-tagline ${light ? "sv-brand-tagline--light" : ""} ${className}`.trim()}
    >
      {text}
    </p>
  );
};

export default BrandTagline;
